export enum PriceListTypes {
	Admin = 0,
	TruckDriver = 1,
	QAISimpleRework = 2,
	QAIVisualControl = 3,
	Resident = 4,
	ForkliftDriver = 5,
	Teamlead = 6,
}
